export default "__VITE_ASSET__DWbd6HzP__"